// @flow
module.exports = function cleanseZohoData(formField: any) {
  if (typeof formField !== 'string') return formField;
  if (formField.length > 120) {
    return `${formField.slice(0, 117)}...`;
  }
  return formField;
};
